/**
 * 输入框防抖指令
 * 支持 Element UI 的 el-input 组件
 * 使用方式: <el-input v-input-debounce="{ fn: debouncedSearch, delay: 300 }"></el-input>
 */
export default {
  inserted(el, binding) {
    const { fn, delay = 300 } = binding.value;
    if (typeof fn !== 'function') {
      console.error('v-input-debounce: fn must be a function');
      return;
    }
    
    let timer = null;
    
    // 处理 Element UI 组件
    const input = el.querySelector('.el-input__inner');
    if (input) {
      input.addEventListener('input', () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          fn();
        }, delay);
      });
      // 处理清空按钮事件（使用事件委托）
      el.addEventListener('click', (e) => {
        if (e.target.classList.contains('el-input__clear')) {
          clearTimeout(timer);
          timer = setTimeout(() => {
            fn();
          }, delay);
        }
      });
    } else {
      // 处理普通输入框
      el.addEventListener('input', () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          fn();
        }, delay);
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/directive/debounce/input-debounce.js